import apiService from '../services/apiService';
import Project from '../models/Project';

export const projectController = {
  getAll: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const endpoint = queryParams ? 'projects?${queryParams}' : 'projects';
      const response = await apiService.get(endpoint);
      const items = response.data?.map(item => Project.fromJSON(item)) || [];
      return { success: true, data: items, total: response.total || items.length };
    } catch (error) {
      return { success: false, data: [], message: error.message || 'Failed to fetch projects' };
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`projects/${id}`);
      return { success: true, data: Project.fromJSON(response.data) };
    } catch (error) {
      return { success: false, data: null, message: error.message };
    }
  },

  create: async (data) => {
    try {
      const item = new Project(data);
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.post('projects', item.toJSON());
      return { success: true, data: Project.fromJSON(response.data), message: 'Project created successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  update: async (id, data) => {
    try {
      const item = new Project({ ...data, id });
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.put(`projects/${id}`, item.toJSON());
      return { success: true, data: Project.fromJSON(response.data), message: 'Project updated successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  delete: async (id) => {
    try {
      await apiService.delete(`projects/${id}`);
      return { success: true, message: 'Project deleted successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  export: async (filters = {}, format = 'csv') => {
    try {
      const queryParams = new URLSearchParams({ ...filters, format }).toString();
      const response = await apiService.get(`projects/export?${queryParams}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  getStatistics: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const endpoint = queryParams ? `projects/statistics?${queryParams}` : 'projects/statistics';
      const response = await apiService.get(endpoint);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: null, message: error.message };
    }
  }
};

export default projectController;